// value is already a percentage (40 for 40%), as the analytics API sends it.
export function formatPercent(value: number, lang: string, digits = 1): string {
  return new Intl.NumberFormat(lang, {
    style: 'percent',
    maximumFractionDigits: digits
  }).format(value / 100)
}

// The symbol the language writes for the currency: € for EUR, but US$ for USD in Spanish.
export function currencySymbol(currency: string, lang: string): string {
  return (
    new Intl.NumberFormat(lang, { style: 'currency', currency })
      .formatToParts(0)
      .find((part) => part.type === 'currency')?.value ?? currency
  )
}
